// test1132
(1132 && 0);
